import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
import { BalanceItem, BalanceItemWithPayments } from '../BalanceItem.js';
import { PaymentGeneral } from '../members/PaymentGeneral.js';
import { BaseOrganization, Organization } from '../Organization.js';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
import { Payment } from '../members/Payment.js';
export class PayableBalance extends AutoEncoder {
    organization;
    amountPaid = 0;
    amountOpen = 0;
    amountPending = 0;
}
__decorate([
    field({ decoder: Organization })
], PayableBalance.prototype, "organization", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 335 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountPending", void 0);
export class PayableBalanceCollection extends AutoEncoder {
    /**
     * Debt you have to other organizations
     */
    organizations = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(PayableBalance) })
], PayableBalanceCollection.prototype, "organizations", void 0);
export class DetailedPayableBalance extends AutoEncoder {
    organization;
    balanceItems = [];
    // todo
    payments = [];
    get filteredBalanceItems() {
        return BalanceItem.filterBalanceItems(this.balanceItems);
    }
    get payableBalanceItems() {
        return BalanceItem.filterPayableBalanceItems(this.balanceItems);
    }
    get discountBalanceItems() {
        return BalanceItem.filterDiscountBalanceItems(this.balanceItems);
    }
    /**
     * Whether the payable items contain items with a VAT rate that is added on top of the price (excluding VAT).
     * When this is the case, the item prices become hard to read (they include rounded VAT), so we show the
     * prices excluding VAT together with a separate VAT overview instead.
     */
    get hasExclusiveVAT() {
        return this.payableBalanceItems.some(item => !item.VATIncluded && !!item.VATPercentage);
    }
    /**
     * VAT of the payable items, grouped per VAT percentage.
     * Based on the full payable prices, so it reconciles with the listed item prices and the total.
     */
    get VATBreakdown() {
        return BalanceItem.getPayableVATBreakdown(this.payableBalanceItems);
    }
}
__decorate([
    field({ decoder: BaseOrganization })
], DetailedPayableBalance.prototype, "organization", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemWithPayments) })
], DetailedPayableBalance.prototype, "balanceItems", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PaymentGeneral) }),
    field({ decoder: new ArrayDecoder(Payment), version: 399 })
], DetailedPayableBalance.prototype, "payments", void 0);
export class DetailedPayableBalanceCollection extends AutoEncoder {
    /**
     * Debt you have to other organizations
     */
    organizations = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(DetailedPayableBalance) })
], DetailedPayableBalanceCollection.prototype, "organizations", void 0);
//# sourceMappingURL=PayableBalanceCollection.js.map